import { Attachment, RequestStatus, SupportRequest } from '../types';
import {
  SupportAttachmentApi,
  SupportRequestApi,
  SupportRequestStatusApi,
} from './apiTypes';
import {
  SUPPORT_REQUEST_STATUS_TO_API,
  SUPPORT_REQUEST_STATUS_TO_UI,
} from './status';

function buildFullName(firstName: string, lastName: string): string {
  return [firstName, lastName].filter(Boolean).join(' ').trim();
}

function mapSupportStatusToUi(status: SupportRequestStatusApi): RequestStatus {
  return SUPPORT_REQUEST_STATUS_TO_UI[status];
}

function mapSupportStatusToApi(status: RequestStatus): SupportRequestStatusApi {
  return SUPPORT_REQUEST_STATUS_TO_API[status];
}

export function mapSupportRequest(api: SupportRequestApi): SupportRequest {
  return {
    id: api.id,
    requestId: api.requestId,
    submittedAt: api.createdDate,
    name: buildFullName(api.firstName, api.lastName),
    assignedAdmin: api.assignedAdminEmail || null,
    status: mapSupportStatusToUi(api.status),
    category: api.category,
    description: api.description,
    resolutionComment: api.statusReason || null,
    ticketType: 'Support',
    createDate: api.createdDate,
    updatedAt: api.lastModifiedDate || null,
    firstName: api.firstName,
    lastName: api.lastName,
    email: api.email,
    primaryEmail: api.primaryEmail,
    phone: api.phone,
    primaryPhone: api.primaryPhone,
    message: api.message,
    startUtc: api.startUtc || null,
    endUtc: api.endUtc || null,
    issueNotTimeDependent: api.isNotTimeDependent,
    dcimDataCenterLocation: api.dcim?.dataCenterLocation,
    dcimUrl: api.dcim?.url,
    dcimProfileId: api.dcim?.profileId,
    dcimDdidSample: api.dcim?.ddidSample,
    attachments: [],
  };
}

export function mapSupportRequestStatusToApi(
  status: RequestStatus,
): SupportRequestStatusApi {
  return mapSupportStatusToApi(status);
}

export function mapSupportAttachments(
  api: SupportAttachmentApi[],
): Attachment[] {
  return api.map(item => ({
    id: item.id,
    name: item.name,
    uploadedAt: item.createdDate,
    url: item.url,
    downloadUrl: item.downloadUrl,
  }));
}
